// extracted by mini-css-extract-plugin
export default {"alert":"DownloadDocumentErrorAlert_alert__EyeGE","message":"DownloadDocumentErrorAlert_message__S9XYB"};